<!-- 表具实时数据 -->
<template>
  <a-row :gutter="24">
    <a-col :md="collapsed? 0: 5" :sm="24">
      <a-card :bordered="false">
          <!-- 按钮操作区域 -->
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear  :placeholder="$t('请输入区域名称')"/>
            <!-- 树-->
            <a-col :md="24" :sm="24">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <!--
                  <span style="user-select: none">
                    <a-tree
                      class="my-area-select-tree"
                      @select="onSelect"     
                      :selectedKeys="selectedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                    </a-tree>
                  </span>
                  -->
                  <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    @node-click="nodeClick"
                    ref="areaTree">
                  </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户编号')">
                  <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户姓名')">
                  <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('上报方式')">
                    <a-select
                      mode="multiple"
                      style="width: 100%"
                      :placeholder="$t('请选择上报方式')"
                      v-model="meterUpWay"
                      @change="handleChangeMeterUpWay"
                    >
                      <a-select-option v-for="(item,key) in SendWayObj" :value="key" :key="key">
                        {{ $t(item) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('阀门是否故障')">
                    <a-select
                      v-model="queryParam.meterValveFault"
                      :placeholder="$t('请选择阀门是否故障')"
                      >
                      <a-select-option :value="0">
                        {{ $t('正常') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('故障') }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('阀门状态')">
                    <a-select
                      mode="multiple"
                      style="width: 100%"
                      :placeholder="$t('请选择阀门状态')"
                      v-model="meterValveStatus"
                      @change="handleChangeMeterValveStatus"
                    >
                      <a-select-option v-for="(item,key) in Mn100FkStatusObj" :value="key" :key="key">
                        {{ $t(item) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('电池状态')">
                    <a-select
                      v-model="queryParam.meterBatteryStatus"
                      :placeholder="$t('请输入电池状态')"
                      >
                      <a-select-option :value="0">
                        {{ $t('正常') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('欠压') }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('有无磁干扰')">
                    <a-select :placeholder="$t('请输入有无磁干扰')" v-model="queryParam.meterMagentic">
                      <a-select-option :value="0">
                        {{ $t('正常') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('有') }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('表类型')">
                    <!--
                    <a-select placeholder="请输入表类型" v-model="queryParam.meterType  ">
                      <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                        {{data.mtCode}}
                      </a-select-option>
                    </a-select>
                    -->
                    <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请表类型')" dictCode="meter_type" />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('表口径')">
                    <a-select
                      mode="multiple"
                      v-model="meterCaliber"
                      :placeholder="$t('请选择表口径')"
                      @change="handleChangeMeterCaliber"
                      >
                      <a-select-option v-for="data in userCaliberList" :key="data.id" :value="data.mtCaliber">
                        DN{{data.mtCaliber}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                
                <a-col :span="8">
                  <a-form-model-item :label="$t('上报时间')">
                    <a-range-picker
                      v-model="date"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      format="YYYY-MM-DD"
                      @change="onDateRangeChange"
                    />
                  </a-form-model-item>
                </a-col>
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls($t('表具实时数据'))">{{ $t('导出') }}</a-button>
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
        <!-- table区域-begin -->
        <div>
          <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a> -->
          <span style="float:right;">
            <!-- <a @click="loadData()"><a-icon type="sync" />刷新</a> -->
            <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
              <template slot="content">
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </template>
            </a-popover>
          </span>
          <!-- </div> -->
          <a-table
            ref="table"
            size="middle"
            tableLayout="fixed"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
            <div slot="filterDropdown">
              <a-card>
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="12" :key="item.key">
                          <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                        </a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </a-card>
            </div>
            <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
            <span slot="action" slot-scope="text, record" class="action">
              <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              <a @click="showMeterCommandQueue(record)">{{ $t('命令队列') }}</a>
              <span >
                <a @click="debugNewCommand(record)">{{ $t('命令下发') }}</a>
              </span>
            </span>
          </a-table>
        </div>
        <meter-up-data-modal ref="modalForm" @ok="modalFormOk"></meter-up-data-modal>
        <debug-newCommand-modal ref="debugNewCommandModal" @ok="modalFormOk"></debug-newCommand-modal>
        <meter-command-queue-modal ref="metrCommandQueueModal" @ok="modalFormOk"></meter-command-queue-modal>
        
      </a-card>
    </a-col>
  </a-row>  
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUpDataModal from './modules/MeterUpDataModal'
  import { getAction,downFile } from '@/api/manage'
  import {isUndefined} from'@/utils/validate'
  import { listSize,filterObj } from '@/utils/util'
  import configService from '@/utils/service/config.service'
  import debugNewCommandModal from './modules/debugNewCommandModal'
  import meterCommandQueueModal from './modules/meterCommandQueueModal'
  import Vue from 'vue'
  import {netTypeObj,Mn100FkStatusObj,SendWayObj} from '@/utils/constants/protocolConstant'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'MeterUpDataList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      MeterUpDataModal,
      debugNewCommandModal,
      meterCommandQueueModal,
      JInput
    },
    data () {
      return {
        description: 'meter_up_data管理页面',
        collapsed: false,
        netTypeObj,
        Mn100FkStatusObj,
        SendWayObj,
       //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/central/meterNthUpDataRecord/list",
          delete: "/central/meterNthUpDataRecord/delete",
          deleteBatch: "/central/meterNthUpDataRecord/deleteBatch",
          exportXlsUrl: "/central/meterNthUpDataRecord/exportXls",
          importExcelUrl: "/central/meterNthUpDataRecord/importExcel",
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
        },
        dictOptions:{},
        userCaliberList:[],  // 表口径
        meterUpWay: [],
        meterValveStatus: [],
        meterCaliber: [],
        /* 排序参数 */
        isorter:{
          column: 'sysTime',
          order: 'desc',
        },
      }
    },
    created() {
      this.initColumns();
      this.queryUserCaliberList();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title:this.$t('用户编号'),
            align:"center",
            dataIndex:'userId',
            width:150,
            ellipsis: true
          },{
            title:this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width:150,
            ellipsis: true
          },{
            title:this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title:this.$t('表端时间'),
            align:"center",
            dataIndex: 'meterTime',
            width:150,
            ellipsis: true
          },{
            title:this.$t('上报时间'),
            align:"center",
            dataIndex: 'sysTime',
            width:150,
            ellipsis: true
          },{
            title:this.$t('阀门是否故障'),
            align:"center",
            dataIndex: 'meterValveFault',
            customRender:(t,r,index) => {
              let data = {"0": "正常","1":"故障"}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },{
            title:this.$t('阀门状态'),
            align:"center",
            dataIndex:'meterValveStatus',
            customRender:(t,r,index) => {
              let data = Mn100FkStatusObj;
              if(isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title:this.$t('上报累计开阀时间(分钟)'),
            align:"center",
            dataIndex: 'meterTotalUse',
            width:150,
            ellipsis: true
          },
          {
            title:this.$t('电池电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage',
            width:100,
            ellipsis: true
          },
          /*
          {
            title:'电池状态',
            align:"center",
            dataIndex: 'meterBatteryStatus',
            customRender:function (t,r,index) {
              let data = {"0": "正常","1":"欠压"}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },
          {
            title:'存储状态',
            align:"center",
            dataIndex: 'meterSaveFault',
            customRender:function (t,r,index) {
              let data = {"0": "正常","1":"故障"}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },*/{
            title:this.$t('上报方式'),
            align:"center",
            dataIndex: 'meterUpWay',
            customRender:(t,r,index) => {
              let data = SendWayObj;
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          /*
          {
            title:'电池状态',
            align:"center",
            dataIndex: 'meterBatteryStatus',
            customRender:function (t,r,index) {
              let data = {"0": "正常","1":"欠压"}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title:'阀门状态',
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender:function (t,r,index) {
              let data = Mn100FkStatusObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title:'磁干扰',
            align:"center",
            dataIndex: 'meterMagetic',
            customRender:function (t,r,index) {
              let data = {"1": "有","0":"正常"}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title:'表端上报数据次数',
            align:"center",
            dataIndex: 'meterUpTimes',
            width:100,
            ellipsis: true
          },{
            title:'上报平台没有回应数',
            align:"center",
            dataIndex: 'meterUpNoResponse',
            width:100,
            ellipsis: true
          },*/
          {
            title:this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            customRender:(t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:250,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      // 新协议远程命令下发
      debugNewCommand(record) {
        
        this.$refs.debugNewCommandModal.edit(record);
        this.$refs.debugNewCommandModal.title = this.$t('命令下发');
          
      },
      showMeterCommandQueue(record) {
        this.$refs.metrCommandQueueModal.edit(record);
      },
      handleChangeMeterUpWay(value) {
        this.queryParam.meterUpWay= value +"";
      },
      handleChangeMeterValveStatus(value) {
        this.queryParam.meterValveStatus= value +"";
      },
      handleChangeMeterCaliber(value) {
        this.queryParam.meterCaliber= value +"";
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      handleMeterUpDataRecord(record) {

      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.meterUpWay = []
        this.meterCaliber = []
        this.meterValveStatus = []
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>